import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Beranda" },
    { path: "/products", label: "Produk" },
    { path: "/gallery", label: "Galeri" },
    { path: "/articles", label: "Artikel" },
    { path: "/contact", label: "Hubungi" },
    { path: "/about", label: "Tentang Kami" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-white/90 dark:bg-background-dark/90 backdrop-blur-md border-b border-[#e4e3dc] dark:border-[#3a362a]">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="text-primary-gold-light hidden md:block transition-all duration-500 ease-in-out">
            <img loading="lazy" src="/assets/favicon.png" alt="" width={50} />
          </div>
          <h1 className="text-2xl font-serif font-bold text-primary-gold-light tracking-tight hidden md:block">
            Jati Antik Furniture
          </h1>
        </div>

        <div className="hidden xl:flex items-center gap-8 absolute left-1/2 transform -translate-x-1/2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors duration-600 ease-in-out ${
                location.pathname === item.path
                  ? "font-bold border-b-2 border-yellow-300 text-[#D4AF37]"
                  : "text-[#171612]"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-6">
          <div className="hidden xl:flex items-center bg-[#f4f3f1] dark:bg-[#2a271a] rounded-full px-4 py-2 w-64 transition-all duration-300 ease-in-out">
            <span className="material-symbols-outlined text-[#857d66] text-xl transition-colors duration-300 ease-in-out">
              search
            </span>
            <input
              className="bg-transparent border-none focus:ring-0 text-sm w-full placeholder:text-[#857d66] transition-all duration-300 ease-in-out"
              placeholder="Cari koleksi..."
              type="text"
            />
          </div>

          {/* Mobile Menu Button - now appears on smaller screens including lg and xl */}
          <button
            className="xl:hidden p-2 text-[#171612] dark:text-white transition-colors duration-300 ease-in-out"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu - now appears on smaller screens including lg and xl */}
      {isMenuOpen && (
        <div className="xl:hidden bg-white dark:bg-background-dark border-t border-[#e4e3dc] dark:border-[#3a362a]">
          <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-4">
            <div className="flex flex-col gap-4">
              <div className="flex items-center bg-[#f4f3f1] dark:bg-[#2a271a] rounded-full px-4 py-2 transition-all duration-300 ease-in-out mb-4">
                <span className="material-symbols-outlined text-[#857d66] text-xl transition-colors duration-300 ease-in-out">
                  search
                </span>
                <input
                  className="bg-transparent border-none focus:ring-0 text-sm w-full placeholder:text-[#857d66] transition-all duration-300 ease-in-out ml-2"
                  placeholder="Cari koleksi..."
                  type="text"
                />
              </div>
              <nav className="flex flex-col gap-4">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`text-sm font-medium py-2 transition-colors duration-300 ease-in-out ${
                      location.pathname === item.path
                        ? "font-bold text-primary-gold-light"
                        : "text-[#171612]/70 dark:text-white/70 hover:text-primary-gold-light"
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
